import React, { Component } from "react"
import ReactLoading from 'react-loading'
import Select from "../../../components/Select"
import { components } from 'react-select'
import helper from "../../../utils/helper"
import auth from "../../../utils/auth"
import cfg from "../../../utils/config"
import axios from "axios"
import CsvDownloader from 'react-csv-downloader'
import pdfMake from 'pdfmake'
import { Badge, Modal, ModalHeader, ModalBody } from 'reactstrap'
import GenericInputDate from "../../../components/GenericInputDate"
import { lnsStatus } from "../../../utils/Enums/lnsStatus"

pdfMake.fonts = {
    Roboto: {
        normal: 'https://cdnjs.cloudflare.com/ajax/libs/pdfmake/0.1.66/fonts/Roboto/Roboto-Regular.ttf',
        bold: 'https://cdnjs.cloudflare.com/ajax/libs/pdfmake/0.1.66/fonts/Roboto/Roboto-Medium.ttf',
        italics: 'https://cdnjs.cloudflare.com/ajax/libs/pdfmake/0.1.66/fonts/Roboto/Roboto-Italic.ttf',
    }
}

class RelatorioGateway extends Component {
    userInfo = auth.getUserInfo()

    state = {
        detalhes: { status: { label: "Todos", value: "TODOS" }, periodo: null },
        carregando_dados: false,
        gerarRelatorio: true,
        relatorioGerado: false,
        optionsStatus: [
            { label: "Todos", value: "TODOS" },
            { label: "Ativo", value: "ONLINE" },
            { label: "Sem comunicação", value: "OFFLINE" },
            { label: "Inativo", value: "INATIVO" }
        ],
        dataRelatorio: [],
        csv: { data: [], columns: [] },
        modalVerPeriodo: false,
        periodo: [],
        gateways: [],
        info: {
            gateways: 'Selecionar gateways traz os dados do gateway selecionado, se vazio será exibido os dados de todos os gateways.',
            periodo: 'Selecionar período traz os dados do período selecionado, se vazio será exibido os dados de hoje.'
        }
    }

    componentDidMount = () => {
        this.getGateways()
    }

    handleChange = (field, value) => {
        const detalhes = Object.assign({}, this.state.detalhes)
        detalhes[field] = value
        this.setState({detalhes})
    }

    gerarRelatorio = () => {
        this.setState({ carregando_dados: true, relatorioGerado: false })

        const detalhes = this.state.detalhes
        const requestURL = cfg.base_api_url + cfg.api_v2 + '/' + this.userInfo.empresa + '/lns/relatorio/gateway/'

        const data  = {
            status: detalhes.status.value,
            periodo: {
                data_inicio: detalhes.periodo.startDate,
                data_fim: detalhes.periodo.endDate
            },
            gateways: detalhes?.gateways?.map(item => item.value)
        }

        axios({
            method: "POST",
            url: requestURL,
            data: data,
            headers: { 'Content-Type': 'application/json', 'Authorization': 'Bearer ' + auth.getToken() }
        }).then(({ data }) => {
            this.formatarCsv(data)

            if(data.gateways.length == 0) {
                helper.dispatchEvent("showAviso", {
                    message: "Dados não encontrados!"
                })

                this.setState({ carregando_dados: false, relatorioGerado: false, dataRelatorio: [] })

                return
            }

            this.setState({ carregando_dados: false, relatorioGerado: true, dataRelatorio: data })
        })
        .catch((error) => {
            helper.dispatchEvent("showAviso", {
                message: error.response.data.message ?? "Erro ao gerar relatório!"
            })
        }).finally(() => {
            this.setState({ carregando_dados: false })
        })
    }

    getGateways = () => {
        this.setState({ carregando_dados: true })
        axios.get(cfg.base_api_url + cfg.api_v2 + '/' + this.userInfo.empresa + '/lns/gateway', { headers: { 'Authorization': 'Bearer ' + auth.getToken() } }).then(({ data }) => {
            this.setState({ gateways: data.results.map(item => ({ label: item.name, value: item.id })), carregando_dados: false })
        }).catch((error) => {
            helper.dispatchEvent("showAviso", {
                message: error.response.data.message ?? "Erro ao buscar gateways!"
            })
        }).finally(() => {
            this.setState({ carregando_dados: false })
        })
    }

    formatarCsv = (data) => {
        const csv = { data: [], columns: [] }
        
        csv.columns = [
            { id: 'c0', displayName: 'Nome' },
            { id: 'c1', displayName: 'Status' },
            { id: 'c2', displayName: 'Qtd. de dispositivos' },
            { id: 'c3', displayName: 'Qtd. de Consumo' },
            { id: 'c4', displayName: 'Qtd. de mensagens' },
            { id: 'c5', displayName: 'Primeira comunicação' },
            { id: 'c6', displayName: 'Última comunicação' },
        ]

        const limitarTexto = (texto) => {
            if (typeof texto !== 'string') 
                texto = texto ? texto.toString() : ''
            let resultado = ''
            let i = 0
            while (i < texto.length) {
                resultado += texto.substring(i, i + 10)
                if (i + 10 < texto.length) 
                    resultado += '\n'
                i += 10
            }
            return resultado
        }

        data.gateways.forEach((item) => {
            const row = {
                c0: limitarTexto(item.name),
                c1: limitarTexto(lnsStatus[item?.state] ?? 'INATIVO'),
                c2: limitarTexto(item?.quantidade_dispositivos ?? "---"),
                c3: limitarTexto(`${item?.total_megas} MB` ?? "---"),
                c4: limitarTexto(item?.total_mensagens ?? "---"),
                c5: limitarTexto(item?.primeira_comunicacao ?? "---"),
                c6: limitarTexto(item?.last_seen_at ? helper.convertDate(item.last_seen_at) : "---"),
            }

            csv.data.push(row)

            if (item.periodo && item.periodo.length > 0) {
                csv.data.push({
                    c0: 'Data do registro',
                    c1: '',
                    c2: '',
                    c3: 'Período',
                    c4: '',
                    c5: '',
                    c6: '',
                    _headerStyle: true
                })

                item.periodo.forEach((periodo) => {
                    csv.data.push({
                        c0: limitarTexto(helper.convertDate(periodo.timestamp, 'timestamp')),
                        c1: '',
                        c2: limitarTexto(periodo.device_count),
                        c3: limitarTexto(`${periodo.total_megas} MB`),
                        c4: limitarTexto(periodo.message_count),
                        c5: '',
                        c6: ''
                    })
                })
            }

            csv.data.push({
                c0: ' ',
                c1: ' ',
                c2: ' ',
                c3: ' ',
                c4: ' ',
                c5: ' ',
                c6: ' ',
                _headerStyle: true
            })
        })

        csv.data.push(
            {
                c0: `Totais`,
                c1: limitarTexto(data.total_gateways || ''),
                c2: '',
                c3: limitarTexto(`${data.total_megas} MB`) || '',
                c4: limitarTexto(data.total_mensagens || ''),
                c5: '',
                c6: ''
            }
        )

        this.setState({ csv })
    }

    exportarPDF = () => {
        const { csv } = this.state

        const columns = csv.columns.map(item => item.displayName)

        let table = []
        let widths = []

        const header_style = {
            fillColor: '#e0e0e0',
            color: '#444',
            bold: true
        }

        const headerRow = columns.map(col => ({
            text: col,
            ...header_style
        }))
        table.push(headerRow)

        columns.forEach(() => {
            widths.push("*")
        })

        csv.data.forEach((item) => {
            let row = []
            
            csv.columns.forEach((col, index) => {
                const key = `c${index}`
                let value = item[key] || ''

                if(item._headerStyle) {
                    row.push({text: value, ...header_style})
                    return
                }

                if (item[key] === 'Totais') {
                    row.push({text: value, ...header_style})
                    return
                }

                row.push({text: value})
            })
            
            table.push(row)
        })

        const pdfOptions = {
            pageOrientation: 'landscape',
            content: [
                {
                    table: {
                        widths: ['*', 80],
                        body: [
                            [
                                {
                                    text: ['\n', '\n', this.userInfo.email],
                                    border: [false, false, false, true]
                                },
                                { image: 'logo', style: 'logo', width: 80, border: [false, false, false, true] }
                            ]
                        ],
                    },
                },
                '\n\n\n',
                {
                    text: 'Relatório de Gateways',
                    style: 'header',
                    alignment: 'center'
                },
                '\n',
                {
                    table: {
                        widths: widths,
                        body: table,
                        headerRows: 1
                    },
                    layout: {
                        fillColor: function (rowIndex, node, columnIndex) {
                            return rowIndex === 0 ? '#e0e0e0' : null;
                        }
                    }
                }
            ],
            styles: {
                header: {
                    fontSize: 18,
                    bold: true,
                    margin: [0, 0, 0, 10]
                }
            },
            images: { 'logo': document.querySelector('div.hdv-logomarca img')?.src, },
        }

        const win = window.open('', '_blank')
        pdfMake.createPdf(pdfOptions).open({}, win)
    }

    modalVerPeriodo = (periodo) => {
        this.setState({ modalVerPeriodo: true, periodo })
    }

    showInfo = (info) => {
        helper.dispatchEvent("showAviso", {
            message: info
        })
    }

    render() {
        const { carregando_dados, gerarRelatorio, relatorioGerado, optionsStatus, detalhes, dataRelatorio, gateways, info } = this.state

        const { Option } = components
        const IconOption = (props) => {
            const colors = {
                "TODOS": '#207fcc',
                "ONLINE": '#2bb33f',
                "OFFLINE": '#e75c4f',
                "INATIVO": '#444444'
            }

            return (
                <Option {...props}>
                    <span className="d-flex align-items-center">
                        <i style={{ fontSize: '16px', color: colors[props.data.value] }} className="fa fa-square mr-1"></i>
                        <b style={{ color: props.isSelected ? 'white' : '#222', fontWeight: props.isSelected ? 'bold' : 'normal', opacity: 1 }}>{props.data.label}</b>
                    </span>
                </Option>
            )
        }
        
        return(
            <div className="hdv-render-div">
                <div className="hdv-default-header mx-3">
                    <span className="screen-menu-desc">
                        <h4>Relatório de Gateways</h4>
                        <div className="gray-background">
                            <i className="las la-wifi la-2x"></i>
                        </div>
                    </span>
                    <ReactLoading className={(carregando_dados) ? "hdv-report-loading" : "hdv-noshow-item"} type="cylon" color="var(--background-menu)" width={50} />
                </div>

                <details open className='custom-summary'>
                    <summary>Filtros</summary>

                    <div className="hdv-form-default" style={{padding: "0 20px 20px"}}>
                        <div className="row">
                            <div className="col-md-6">
                                <label>
                                    Período
                                    &nbsp;
                                    <i className="las la-info-circle" style={{cursor: "pointer"}} title={info.periodo} onClick={() => this.showInfo(info.periodo)}></i>
                                </label>
                                <GenericInputDate
                                    onChange={(objectDate) => this.handleChange("periodo", objectDate)}
                                    haveInitialValue
                                />
                            </div>
                            <div className="col-md-6">
                                <label className="required">Status</label>
                                <Select
                                    components={{ Option: IconOption }}
                                    options={optionsStatus}
                                    value={detalhes.status}
                                    onChange={(e) => this.handleChange("status", e)}
                                />
                            </div>
                        </div>
                        <div className="row">
                            <div className="col-md-12">
                                <label>
                                    Gateways
                                    &nbsp;
                                    <i className="las la-info-circle" style={{cursor: "pointer"}} title={info.gateways} onClick={() => this.showInfo(info.gateways)}></i>
                                </label>
                                <Select
                                    forceHeightAuto
                                    options={gateways}
                                    value={detalhes.gateways}
                                    onChange={(e) => this.handleChange("gateways", e)}
                                    isMulti={true}
                                    disabled={carregando_dados}
                                    placeholder="Todos"
                                />
                            </div>
                        </div>
                    </div>
                </details>

                <div className="hdv-btn-group">
                    <button disabled={!gerarRelatorio} onClick={this.gerarRelatorio} className="hdv-btn-forms hdv-btn-blue">Gerar Relatório</button>

                    <CsvDownloader
                        style={{ border: 'none' }}
                        columns={this.state.csv.columns}
                        datas={this.state.csv.data}
                        filename={`relatorio_lns_gateways.csv`}
                        separator=";"
                    >
                        <button disabled={!relatorioGerado} className="hdv-btn-forms hdv-btn-green">Exportar CSV</button>
                    </CsvDownloader>

                    <button onClick={this.exportarPDF} disabled={!relatorioGerado} className="hdv-btn-forms hdv-btn-red">Exportar PDF</button>
                </div>

                {relatorioGerado ?
                    <table className="table afira-table">
                        <thead>
                            <tr>
                                <th>Nome</th>
                                <th>Status</th>
                                <th>Dispositivos</th>
                                <th>Consumo</th>
                                <th>Mensagens</th>
                                <th>Primeira comunicação</th>
                                <th>Última comunicação</th>
                                <th>Período</th>
                            </tr>
                        </thead>
                        <tbody>
                            {
                                dataRelatorio.gateways.map((item, index) => {
                                    const status = {
                                        "1": 'success',
                                        "2": 'danger',
                                        "3": 'warning'
                                    }

                                    return (
                                        <tr key={index}>
                                            <td>{item.name}</td>
                                            <td>{<Badge color={status[item.state] ?? 'secondary'}>{helper.convertLabelStatusLNS(lnsStatus[item.state]) ?? 'Nunca comunicou'}</Badge>}</td>
                                            <td>{item?.quantidade_dispositivos ?? "---"}</td>
                                            <td>{item?.total_megas ? `${item?.total_megas} MB` : "---"}</td>
                                            <td>{item?.total_mensagens ?? "---"}</td>
                                            <td>{item?.primeira_comunicacao ? item.primeira_comunicacao : "---"}</td>
                                            <td>{item?.last_seen_at ? helper.convertDate(item.last_seen_at) : "---"}</td>
                                            <td><button onClick={() => this.modalVerPeriodo(item.periodo)} className="hdv-btn-forms hdv-btn-blue">Ver</button></td>
                                        </tr>
                                    )
                                })
                            }
                            <tr>
                                <td colSpan={1}>Totais</td>
                                <td colSpan={2} title="Total de gateways">{dataRelatorio.total_gateways}</td>
                                <td colSpan={1} title="Total de Consumo">{dataRelatorio.total_megas} MB</td>
                                <td colSpan={4} title="Total de mensagens">{dataRelatorio.total_mensagens}</td>
                            </tr>
                        </tbody>
                    </table>
                : null}

                <Modal isOpen={this.state.modalVerPeriodo} toggle={() => this.setState({ modalVerPeriodo: false })} size="lg">
                    <ModalHeader toggle={() => this.setState({ modalVerPeriodo: false })}>Detalhes do Período</ModalHeader>
                    <ModalBody>
                        <div className="hdv-form-default">
                            {this.state.periodo.length > 0 ?
                                <table className="table afira-table">
                                    <thead>
                                        <tr>
                                            <th>Data</th>
                                            <th>Dispositivos</th>
                                            <th>Consumo</th>
                                            <th>Mensagens</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {
                                            this.state.periodo.map((item, index) => {
                                                return (
                                                    <tr key={index}>
                                                        <td>{item.data_hora}</td>
                                                        <td>{item.device_count}</td>
                                                        <td>{item.total_megas} MB</td>
                                                        <td>{item.total_mensagens}</td>
                                                    </tr>
                                                )
                                            })
                                        }
                                    </tbody>
                                </table>
                                :
                                <div className="row justify-content-center">
                                    <p>Sem dados no período</p>
                                </div>
                            }

                        </div>
                    </ModalBody>
                </Modal>
            </div>
        ) 
    }
}

export default RelatorioGateway